import axios from "axios";
import api from "@/app/lib/axios";

import { RainState } from "@/types/rain";

// Rain lives on Laravel next to the chat (Reverb + Sanctum), so it uses the
// default `api` instance.

/**
 * The rain currently counting down. Public — `joined` and `eligibility` are the
 * only per-viewer fields and they come back empty for a guest.
 */
export async function fetchRain(): Promise<{ enabled: boolean; rain: RainState | null }> {
    const { data } = await api.get<{ enabled: boolean; rain: RainState | null }>("rain");
    return data;
}

/** Join the open rain. Rejects with the server's reason (not open / not eligible). */
export async function joinRain(): Promise<RainState> {
    try {
        const { data } = await api.post<{ rain: RainState }>("rain/join");
        return data.rain;
    } catch (err) {
        if (axios.isAxiosError(err)) {
            throw new Error(err.response?.data?.message ?? "Could not join the rain.");
        }
        throw err;
    }
}

/**
 * Put your own Soko Points into the pot. Returns the refreshed cycle plus the
 * tipper's new balance, so the header doesn't have to re-fetch the user.
 */
export async function tipRain(amount: number): Promise<{ rain: RainState; soko_points: number }> {
    try {
        const { data } = await api.post<{ rain: RainState; soko_points: number }>("rain/tip", { amount });
        return data;
    } catch (err) {
        if (axios.isAxiosError(err)) {
            const body = err.response?.data;
            throw new Error(body?.message ?? body?.errors?.amount?.[0] ?? "Could not tip the rain.");
        }
        throw err;
    }
}
